import { useContext } from 'react';
import { AttachDocumentContext } from 'src/sections/attach_document/AttachDocumentContext';

const useAttachDocument = () => {
  const context = useContext(AttachDocumentContext);
  if (!context)
    throw new Error('Attach Document context must be used inside AttachDocumentContextProvider');
  return context;
};

export default useAttachDocument;
